import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DataService } from 'src/app/_services';

@Component({
  selector: 'app-investmentitem',
  templateUrl: './investmentitem.component.html',
  styleUrls: ['./investmentitem.component.css', './custom_style.css', './boot-outline-btn.css']
})
export class InvestmentitemComponent implements OnInit {

  @Input('request') request: any;
  @Output() loadRequest = new EventEmitter();
  @Output() loadPortfolio = new EventEmitter();
  @Input('loading') loading = false;
  @Input('active') active = false;

  request_loading = false; 
  constructor(private dataService: DataService) { 

    this.dataService.investmentHasLoaded.subscribe(res => {
      this.loading = false;
    });
    
  }

  ngOnInit() {
  }
  openLoan(request) {
    this.loading = true;
    this.loadRequest.emit({ request: request });
  }
}
